import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The combined edit page is gone — contact and identity details are edited separately now. Kept
 * as a redirect so an older link or a bookmark lands somewhere useful instead of on a 404.
 */
export const Route = createFileRoute("/profile_/edit")({
  beforeLoad: () => {
    throw redirect({ to: "/profile/contact" });
  },
});
